var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "#469BE3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5V4.1875L7 0.25L14 4.1875V5.5H12.6875H1.3125H0ZM7 1.78125L2.65234 4.1875H11.3203L7 1.78125ZM3.0625 6.375V10.75H4.8125V6.375H6.125V10.75H7.875V6.375H9.1875V10.75H10.9375V6.375H12.25V10.75H12.4688H13.125V12.0625H12.4688H1.53125H0.875V10.75H1.53125H1.75V6.375H3.0625ZM0 12.9375H0.65625H13.3438H14V14.25H13.3438H0.65625H0V12.9375Z",
    fill: "#469BE3",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicIcon);
export default __webpack_public_path__ + "static/media/academic-icon.7f5ef64ea2ca1705683c141b726b1b16.svg";
export { ForwardRef as ReactComponent };